module.exports = __webpack_public_path__ + "img/forms.b86352a1.png";